<div class="section is-fullheight" id="error-third-party-issue">
  <div class="container has-text-centered">
    <Heading />
  </div>

  <div class="container has-text-centered">
    <div class="column is-6 is-offset-3">
      <div class="box mt-2">
        <div class="notification is-warning has-text-left">
          <p>
            Die Sicherheitseinstellungen deines Browers schränken die
            Funktionalität dieser Anwendung ein.
            <br />
            <br />Bitte öffne die Url OHNE Inkognitomodus oder öffne die
            Anwendung direkt:
          </p>
        </div>

        <a
          class="button is-block is-outlined is-large is-fullwidth"
          href="{permalink}"
          target="_blank"
        >In neuem Fenster öffnen</a>
      </div>
    </div>
  </div>
  <FooterNav />
</div>

<script>
import Heading from "./Heading.svelte";
import FooterNav from "./FooterNav.svelte";

let permalink = window.appConfig.permalink;
</script>

<style type="text/scss">
.notification p {
  font-weight: 400;
}
.hero.is-success {
  background: #f2f6fa;
}
.hero .nav,
.hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.box {
  margin-top: 5rem;
}
input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}

.login-hr {
  border-bottom: 1px solid black;
}

.has-text-black {
  color: black;
}

.fa {
  margin-left: 5px;
}
</style>
